module.exports = __webpack_public_path__ + "img/full3-min.d2403dea.png";